import { useState } from 'react';
import { useZakeke } from 'zakeke-configurator-react';

const usePdf = () => {
  const { getPDF } = useZakeke();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getPdfUrl = async (): Promise<string> => {
    try {
      setIsLoading(true);
      return await getPDF();
    } catch (ex) {
      console.error(ex);
      throw ex;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    getPdfUrl,
  };
};

export { usePdf };
